import { type Control } from 'react-hook-form'

import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
    useCurrency,
} from '@/shared'

import { type InvoiceFormValues } from './invoice-form'

interface Props {
    control: Control<InvoiceFormValues>
}

export const InvoiceFormCurrency = ({ control }: Props) => {
    const { currency } = useCurrency()

    return (
        <FormField
            control={control}
            name="currency"
            render={({ field }) => (
                <FormItem className="w-full">
                    <FormLabel className="required">Currency</FormLabel>
                    <FormControl>
                        <Select value={field.value} onValueChange={field.onChange}>
                            <SelectTrigger>
                                <SelectValue placeholder="Choose currency" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectGroup>
                                    {currency?.data?.map((c, index) => (
                                        <SelectItem key={index} value={c.name}>
                                            {c.symbol} {c.name}
                                        </SelectItem>
                                    ))}
                                </SelectGroup>
                            </SelectContent>
                        </Select>
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
